// extracted by mini-css-extract-plugin
module.exports = {"cover":"_1xBEzCv33-O0iOGY7Bsgso","btnUpdateCover":"_2ZQ12Zz8VI69VhocJPcbg-","content":"_3pz86soWc1nvE_7hBXJCD9","avatar":"_9ZcLfAty5LBrCjQdjEatG","name":"_3KmxWjHWpJDgbXLL6JQ-Jk"};